/**
 * Timer Component
 *
 * Displays elapsed time for the current level in MM:SS format.
 */

import { formatTime } from '@core/levels';
import styles from './Timer.module.scss';

export interface TimerProps {
  currentTime: number;
  bestTime?: number;
}

export const Timer = ({ currentTime, bestTime }: TimerProps) => {
  return (
    <div className={styles.timer}>
      <div className={styles.current}>
        <span className={styles.label}>Time:</span>
        <span className={styles.value}>{formatTime(currentTime)}</span>
      </div>
      {bestTime !== undefined && (
        <div className={styles.best}>
          <span className={styles.label}>Best:</span>
          <span className={styles.value}>{formatTime(bestTime)}</span>
        </div>
      )}
    </div>
  );
};